export const FAQ_ROUTE = 'prawo-jazdy-faq';
